import { render, staticRenderFns } from "./AnnounceDetail.vue?vue&type=template&id=22f87302&scoped=true&"
import script from "./AnnounceDetail.vue?vue&type=script&lang=js&"
export * from "./AnnounceDetail.vue?vue&type=script&lang=js&"
import style0 from "./AnnounceDetail.vue?vue&type=style&index=0&id=22f87302&prod&lang=css&"
import style1 from "./AnnounceDetail.vue?vue&type=style&index=1&id=22f87302&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f87302",
  null
  
)

export default component.exports